import React from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import { Helmet } from 'react-helmet';
import _ from 'lodash';
import { BigBreadcrumbs, WidgetGrid } from '../../../components';
import { requestReferralsByCategory } from '../../../store/referral-directory/ReferralDirectoryActions';
import { hostTitle } from '../../../config/ui';

class ReferralCategoryDetail extends React.Component {

  componentWillMount() {
    this.props.getReferralsByCategory(this.props.params.id, {
      tenantID: this.props.tenantId,
    });
  }

  onCancel = () => {
    hashHistory.push(`/referral-category/`);
  };

  detailReferral = (id) => {
    hashHistory.push(`/referral-directory/detail/${id}`);
  };

  render() {
    const {
      data: { data, isLoading },
    } = this.props;

    return (
      <div id="content">
        <Helmet title={`Category Referral List – ${hostTitle()}`} />
        <BigBreadcrumbs
          items={[
            'Resource Library',
            { title: 'Referral Category', route: '/referral-category' },
            'Detail',
          ]}
          icon="fa fa-fw fa-book"
          className=""
        />

        <WidgetGrid>
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <div className="product-content product-wrap clearfix product-deatil">
                {isLoading &&
                  <div className="spinner"></div>
                }
                  <div className="row">
                    <div className="col-md-12">
                      <button
                        className="btn btn-primary pull-right"
                        onClick={this.onCancel}>
                        Back
                      </button>
                      <h2 className="name">
                      Provider Details - {this.props.params.category}
                      </h2>
                      <hr className="simple" />
                      <div className="row">
                      <div className="col-md-12">
                        <br />
                        {(data.length > 0) && (
                          <dl>
                            <dd>
                              {data && 
                                data.map(el => (
                                <li key={el.id}>
                                    <strong><span>
                                      <a
                                        onClick={() =>
                                          this.detailReferral(
                                            el.id
                                          )
                                        } 
                                      >{el.organization}</a>
                                    </span></strong>
                                  <br />
                                </li>
                                ))}
                            </dd>
                          </dl>
                        )}
                        {(data.length === 0) && (
                          <strong><span>
                            No providers available for this category.
                          </span></strong>
                        )}
                        </div>
                      </div>

                    </div>
                  </div>
              </div>
            </div>
          </div>
        </WidgetGrid>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    data: state.referraldirectory,
    tenantId: state.currentUser.queryParams.tenantId,
  }),
  dispatch => ({
    getReferralsByCategory: (categoryId, params) => dispatch(requestReferralsByCategory(categoryId, params)),
  }),
)(ReferralCategoryDetail);



// WEBPACK FOOTER //
// ./src/routes/resource-library/containers/ReferralCategoryDetail.js